import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

import { createAuthSlice } from './auth/auth.store';
import { createProposalSlice } from './proposal/proposal.store';
import { createSelectedLoanSimulationSlice } from './selected-loan-simulation/selected-loan-simulation.store';
import { createOptionsSlice } from './options/options.store';
import { createErrorSlice } from './error/error.store';
import { createValidationSlice } from './validation/validation.store';
import { createConfirmedSlice } from './confirmed/confirmed.store';
import { createHistorySlice } from './history/history.store';
import { createSettingsSlice } from './settings/settings.store';
import { createUtilsSlice } from './utils/utils.store';
import { createFaqSlice } from './faq/faq.store';
import { createRemoteConfigSlice } from './remote-config/remote-config.store';

import { AppStore } from './types';

export const useAppStore = create<AppStore>()(
  persist(
    (...a) => ({
      ...createAuthSlice(...a),
      ...createProposalSlice(...a),
      ...createSelectedLoanSimulationSlice(...a),
      ...createOptionsSlice(...a),
      ...createErrorSlice(...a),
      ...createValidationSlice(...a),
      ...createConfirmedSlice(...a),
      ...createHistorySlice(...a),
      ...createSettingsSlice(...a),
      ...createUtilsSlice(...a),
      ...createFaqSlice(...a),
      ...createRemoteConfigSlice(),
    }),
    {
      name: 'app-storage',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        token: state.token,
        proposal: state.proposal,
        loading: state.loading,
        loanSimulation: state.loanSimulation,
        terms: state.terms,
        privatePolicy: state.privatePolicy,
        history: state.history,
        paymentPoolingIntervals: state.paymentPoolingIntervals,
        emailValidationInterval: state.emailValidationInterval,
        idwallPoolingIntervals: state.idwallPoolingIntervals,
        faqData: state.faqData,
        remoteConfigData: state.remoteConfigData,
      }),
    }
  )
);
